<template>
  <div>
    <a href="#main-content" class="ln-skip-link" aria-roledescription="Nuoroda">Pereiti prie pagrindinio turinio</a>
    <header v-if="configReady" class="ln-blazon ln-subtitle-text noselect" id="ln-district-blazon">
      <router-link to="/">
        <img class="ln-logo mr-3 ln-pointer" :src="districtBlazon" :alt="districtTitle + ' logotipas'" />
      </router-link>
      <span>
        {{ districtTitle }} dokumentų paieška
        <span v-if="isAuthenticated">(VIDINĖ)</span>
      </span>
      <div v-if="showTranslateDropdown" class="ln-translate-select-wrapper float-right ml-3">
        <label for="ln-browser-translate-select" class="sr-only">Puslapio vertimo kalba</label>
        <b-form-select
          id="ln-browser-translate-select"
          v-model="selectedTranslateLanguage"
          :options="translateLanguageOptions"
          :disabled="!isBuiltInTranslateAvailable"
          class="ln-translate-select"
          :title="translateSelectTitle"
          size="sm"
          @change="onTranslateLanguageChange"
          aria-label="Puslapio vertimo kalbos pasirinkimas"
        ></b-form-select>
      </div>
      <!-- <font-awesome-icon
        class="float-right ml-3"
        v-if="isAuthenticated && isAuthenticatedAdmin"
        icon="ellipsis-v"
        title="Naudotojų valdymas"
        @click="$router.push('/manageinternaluser')"
      /> -->
      <router-link
        v-if="isAuthenticated"
        to="/logininternaluser"
        class="ln-success float-right ln-pointer ln-auth-user-link"
        aria-label="Prisijungęs vidinis naudotojas"
        aria-roledescription="Nuoroda"
      >
        <font-awesome-icon icon="user" aria-hidden="true" />
        <span v-if="loggedInUserName" class="ln-auth-username">{{ loggedInUserName }}</span>
      </router-link>
      <router-link
        v-if="showLogin && !isAuthenticated"
        to="/logininternaluser"
        class="ln-primary ln-pointer ln-login-icon"
        aria-label="Prisijungti vidiniam naudotojui"
        aria-roledescription="Nuoroda"
      >
        <font-awesome-icon icon="sign-in-alt" aria-hidden="true" />
      </router-link>
      <!-- <i class="fas fa-ellipsis-v"></i> -->
    </header>
    <div
      v-if="showTranslationDisclaimer"
      class="ln-translation-disclaimer"
      role="status"
      aria-live="polite"
    >
      {{ translationDisclaimerText }}
    </div>
    <main id="main-content" class="container mt-3">
      <div class="mt-3">
        <router-view></router-view>
      </div>
    </main>
    <footer v-if="showAccessibilityLink" class="ln-footer">
      <a
        :href="accessibilityHref"
        target="_blank"
        rel="noopener"
        class="ln-primary"
        aria-roledescription="Nuoroda"
      >Prieinamumo pareiškimas</a>
    </footer>
  </div>
</template>
<script>
//import auth from "./_Helpers/auth-header";
import appconfig from "./_Services/appconfig.js";
import { userService } from "./_Services/user-service";

export default {
  name: "district-main",
  created() {
    this.originalTextByNode = new WeakMap();
    this.translatorByLanguage = {};
    this.translationObserver = null;
    this.translationDebounceTimer = null;
    this.isTranslating = false;
  },
  async mounted() {
    this.isBuiltInTranslateAvailable = await this.detectBuiltInTranslateAvailability();

    const preferredLanguage = localStorage.getItem("preferredTranslateLanguage");
    if (preferredLanguage && this.translateLanguageOptions.some((o) => o.value === preferredLanguage)) {
      this.selectedTranslateLanguage = preferredLanguage;

      if (this.isBuiltInTranslateAvailable && preferredLanguage) {
        this.$nextTick(() => {
          this.startTranslationObserver();
          this.translateCurrentPage(preferredLanguage);
        });
      }
    }
  },
  beforeDestroy() {
    this.stopTranslationObserver();
  },
  computed: {
    districtBlazon() {
      return appconfig.districtBlazonBase64;
    },
    districtTitle() {
      return appconfig.districtTitle;
    },
    configReady() {
      return appconfig != undefined;
    },
    isAuthenticated() {
      //console.log(auth());
      //return auth() != "NoAuth";
      return userService.isAuthorized();
    },
    isAuthenticatedAdmin() {
      //console.log(auth());
      //return auth() != "NoAuth";
      const token = userService.tokenData() || {};
      return token.Role == 1;
    },
    loggedInUserName() {
      if (!this.isAuthenticated) return "";

      const token = userService.tokenData() || {};
      return (
        token.userName ||
        token.UserName ||
        token.preferred_username ||
        token.unique_name ||
        token.name ||
        token.email ||
        ""
      );
    },
    showLogin() {
      return process.env.VUE_APP_SHOW_LOGIN === "true";
    },
    showAccessibilityLink() {
      return this.$route.path === "/" || this.$route.path === "/list";
    },
    accessibilityHref() {
      return this.$router.resolve("/prieinamumas").href;
    },
    translateLanguageOptions() {
      return [
        { value: "", text: "LT" },
        { value: "en", text: "EN" },
        { value: "pl", text: "PL" },
        { value: "de", text: "DE" },
        { value: "ru", text: "RU" },
      ];
    },
    translateSelectTitle() {
      if (this.isBuiltInTranslateAvailable) {
        return "";
      }

      if (this.translateDisabledReason) {
        return this.translateDisabledReason;
      }

      return "Naršyklė nepalaiko integruotos vertimo API. Remomenduojama naudoti Google Chrome arba Microsoft Edge naršykles.";
    },
    showTranslationDisclaimer() {
      return !!this.selectedTranslateLanguage && this.selectedTranslateLanguage !== "lt";
    },
    translationDisclaimerText() {
      const byLanguage = {
        en: "AI-generated translation may be inaccurate.",
        pl: "Tlumaczenie wygenerowane przez AI moze byc niedokladne.",
        de: "Die von KI erzeugte Uebersetzung kann ungenau sein.",
        ru: "Пepeвoд, coздaнный ИИ, мoжeт быть нeтoчным.",
      };

      return byLanguage[this.selectedTranslateLanguage] || byLanguage.en;
    },
    showTranslateDropdown() {
      return (process.env.VUE_APP_TRANSLATE || "").toUpperCase() === "TRUE";
    },
  },
  methods: {
    getSourceLanguage() {
      return (document.documentElement.getAttribute("lang") || "lt").toLowerCase();
    },
    async isLanguagePairAvailable(targetLanguage) {
      const sourceLanguage = this.getSourceLanguage();

      if (window.Translator && typeof window.Translator.availability === "function") {
        const availability = await window.Translator.availability({
          sourceLanguage,
          targetLanguage,
        });
        return availability !== "unavailable";
      }

      if (window.ai && window.ai.translator && typeof window.ai.translator.capabilities === "function") {
        const caps = await window.ai.translator.capabilities({
          sourceLanguage,
          targetLanguage,
        });
        return !!caps && caps.available !== "no";
      }

      return true;
    },
    async detectBuiltInTranslateAvailability() {
      if (typeof window === "undefined") {
        return false;
      }

      const sourceLanguage = this.getSourceLanguage();

      try {
        if (window.ai && window.ai.translator) {
          if (typeof window.ai.translator.capabilities === "function") {
            const caps = await window.ai.translator.capabilities();
            return !!caps && caps.available !== "no";
          }

          return typeof window.ai.translator.create === "function";
        }

        if (window.Translator) {
          if (typeof window.Translator.availability === "function") {
            const availability = await window.Translator.availability({
              sourceLanguage,
              targetLanguage: "en",
            });
            return availability && availability !== "unavailable";
          }

          return typeof window.Translator.create === "function";
        }
      } catch (err) {
        console.warn("Built-in translate API check failed:", err);
        this.translateDisabledReason = "Nepavyko inicijuoti naršyklės vertimo API";
        return false;
      }

      return false;
    },
    async getTranslator(targetLanguage) {
      if (!targetLanguage) return null;
      if (this.translatorByLanguage[targetLanguage]) return this.translatorByLanguage[targetLanguage];

      const sourceLanguage = this.getSourceLanguage();
      const isPairAvailable = await this.isLanguagePairAvailable(targetLanguage);
      if (!isPairAvailable) {
        throw new Error("Selected language pair is unavailable in built-in translation API");
      }

      if (window.ai && window.ai.translator && typeof window.ai.translator.create === "function") {
        const translator = await window.ai.translator.create({ sourceLanguage, targetLanguage });
        this.translatorByLanguage[targetLanguage] = translator;
        return translator;
      }

      if (window.Translator && typeof window.Translator.create === "function") {
        const translator = await window.Translator.create({ sourceLanguage, targetLanguage });
        this.translatorByLanguage[targetLanguage] = translator;
        return translator;
      }

      return null;
    },
    getTranslatableTextNodes() {
      if (!document || !document.body) return [];

      const ignoredTags = new Set(["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA", "OPTION"]);
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
      const nodes = [];
      let current = walker.nextNode();

      while (current) {
        const parent = current.parentElement;
        const text = current.nodeValue;
        if (
          parent &&
          !ignoredTags.has(parent.tagName) &&
          text &&
          text.trim().length > 0 &&
          !(parent.closest && parent.closest(".ln-translate-select-wrapper")) &&
          !(parent.closest && parent.closest(".ln-translation-disclaimer"))
        ) {
          nodes.push(current);
          if (!this.originalTextByNode.has(current)) {
            this.originalTextByNode.set(current, current.nodeValue);
          }
        }

        current = walker.nextNode();
      }

      return nodes;
    },
    restoreOriginalTexts() {
      const nodes = this.getTranslatableTextNodes();
      nodes.forEach((node) => {
        if (this.originalTextByNode.has(node)) {
          node.nodeValue = this.originalTextByNode.get(node);
        }
      });
    },
    startTranslationObserver() {
      if (typeof window === "undefined" || !window.MutationObserver) return;
      if (this.translationObserver) return;

      const target = document.getElementById("main-content");
      if (!target) return;

      this.translationObserver = new MutationObserver(() => {
        if (!this.selectedTranslateLanguage || !this.isBuiltInTranslateAvailable || this.isTranslating) {
          return;
        }

        if (this.translationDebounceTimer) {
          clearTimeout(this.translationDebounceTimer);
        }

        this.translationDebounceTimer = setTimeout(() => {
          this.translateCurrentPage(this.selectedTranslateLanguage);
        }, 250);
      });

      this.translationObserver.observe(target, {
        subtree: true,
        childList: true,
        characterData: true,
      });
    },
    stopTranslationObserver() {
      if (this.translationObserver) {
        this.translationObserver.disconnect();
        this.translationObserver = null;
      }

      if (this.translationDebounceTimer) {
        clearTimeout(this.translationDebounceTimer);
        this.translationDebounceTimer = null;
      }
    },
    async translateCurrentPage(targetLanguage) {
      if (this.isTranslating) return;

      this.isTranslating = true;
      try {
        const translator = await this.getTranslator(targetLanguage);
        if (!translator) return;

        const nodes = this.getTranslatableTextNodes();
        for (let i = 0; i < nodes.length; i += 20) {
          const chunk = nodes.slice(i, i + 20);
          const translated = await Promise.all(
            chunk.map(async (node) => {
              const original = this.originalTextByNode.get(node) || node.nodeValue;
              if (!original || !original.trim()) return node.nodeValue;
              if (typeof translator.translate === "function") {
                return translator.translate(original);
              }
              if (typeof translator.translateText === "function") {
                return translator.translateText(original);
              }
              return original;
            })
          );

          chunk.forEach((node, idx) => {
            if (typeof translated[idx] === "string") {
              node.nodeValue = translated[idx];
            }
          });
        }
      } catch (err) {
        console.warn("Built-in translation failed:", err);
        this.restoreOriginalTexts();
        this.stopTranslationObserver();
        this.isBuiltInTranslateAvailable = false;
        this.translateDisabledReason = "Built-in translation failed: API nepasiekiama";
        this.selectedTranslateLanguage = "";
        localStorage.setItem("preferredTranslateLanguage", "");
      } finally {
        this.isTranslating = false;
      }
    },
    async onTranslateLanguageChange(value) {
      localStorage.setItem("preferredTranslateLanguage", value || "");

      if (!this.isBuiltInTranslateAvailable) return;

      if (!value) {
        this.stopTranslationObserver();
        this.restoreOriginalTexts();
        return;
      }

      await this.$nextTick();
      this.startTranslationObserver();
      await this.translateCurrentPage(value);
    },
  },
  data() {
    return {
      clasifs: {},
      ready: false,
      publicPath: process.env.BASE_URL,
      selectedTranslateLanguage: "",
      isBuiltInTranslateAvailable: false,
      translateDisabledReason: "",
    };
  },
  watch: {
    "$route.fullPath"() {
      if (!this.isBuiltInTranslateAvailable || !this.selectedTranslateLanguage) return;

      this.$nextTick(() => {
        this.translateCurrentPage(this.selectedTranslateLanguage);
        setTimeout(() => this.translateCurrentPage(this.selectedTranslateLanguage), 400);
        setTimeout(() => this.translateCurrentPage(this.selectedTranslateLanguage), 900);
      });
    },
  },
};
</script>
<style src="./Assets/css/site.css"></style>
<style src="@vueform/multiselect/themes/default.css"></style>
<style>
.ln-skip-link {
  position: absolute;
  left: -9999px;
  top: 0;
  z-index: 1080;
  padding: 0.5rem 1rem;
  background: #0b5ed7;
  color: #fff;
  text-decoration: none;
  border-radius: 0 0 4px 0;
}
.ln-skip-link:focus,
.ln-skip-link:focus-visible {
  left: 0;
  outline: 2px solid #fff;
  outline-offset: 2px;
}

.ln-translate-select-wrapper {
  width: 60px;
  display: inline-flex;
  align-items: center;
}

.ln-translate-select {
  min-height: 26px;
  font-size: 12px;
  padding-top: 1px;
  padding-bottom: 1px;
}

.ln-translation-disclaimer {
  margin: 0;
  padding: 8px 12px;
  background: #fff3cd;
  border-top: 1px solid #ffe69c;
  border-bottom: 1px solid #ffe69c;
  color: #664d03;
  font-size: 12px;
  line-height: 1.35;
  text-align: center;
}

.ln-auth-user-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.ln-auth-username {
  font-size: 12px;
  line-height: 1;
}

@media all and (max-width: 576px) {
  .ln-translate-select-wrapper {
    width: 82px;
  }
}
</style>
